import { render, staticRenderFns } from "./FeaturePreview.vue?vue&type=template&id=543c87c6&scoped=true"
import script from "./FeaturePreview.vue?vue&type=script&lang=js"
export * from "./FeaturePreview.vue?vue&type=script&lang=js"
import style0 from "./FeaturePreview.vue?vue&type=style&index=0&id=543c87c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c87c6",
  null
  
)

export default component.exports